import React from 'react';
import { createRoute, icons } from '../utils/CustomFunc';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NewTabBtns = ({
    links = []
}) => {
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const urlCode = useSelector(state => state.urlCode);

    const IconComponent = (props) => {
        const Icon = props.icon;
        return Icon ? <Icon {...props} /> : <></>
    }

    const navigateToRoute = ({ route, params }) => {
        let __urlData = { ...searchParams, ...params };
        if (route.includes('http')) {
            let paramString = new URLSearchParams(__urlData);
            if (Object.keys(__urlData).length) {
                if (route.includes("?")) {
                    route += `&${paramString}`
                } else {
                    route += `?${paramString}`
                }
            };
            window.open(route, '_blank');
        } else {
            let _route = createRoute({
                route,
                urlCode,
                params: __urlData
            });
            window.open(_route, '_blank');
        }
    }

    return (
        <>
            {
                links.length ?
                    links.map((item, indx) => (
                        <div style={item.containerStyle} key={indx}>
                            <p style={item.titleStyle}>{item.title}</p>
                            <div className={"corporate-plant-btn-wrapper"}>
                                {
                                    item.buttons.map((btn, btnIndx) => (
                                        <div
                                            key={`btn-${btnIndx}`}
                                            style={btn.style}
                                            onClick={() => {
                                                navigateToRoute(btn)
                                            }}
                                        >
                                            <div style={{ display: "block", textAlign: "center" }}>
                                                {
                                                    btn.img ?
                                                        <img src={btn.img.url} style={{ ...btn.img.style }} /> :
                                                        <IconComponent icon={icons[btn.icon]} style={{ paddingLeft: 10, fontSize: 30 }} />

                                                }
                                                <div style={{ padding: 0, margin: 0, paddingTop: 10 }}>{btn.label}</div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    )) : <></>
            }
        </>

    )
};

export default NewTabBtns;